import { useRef } from "react"
import {
  //useFrame,
  extend,
  useThree
} from '@react-three/fiber'
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
//import { gyro } from "../helpers/gyro"

extend({ OrbitControls })

export const CameraControls = () => {

  const {
    camera,
    gl: { domElement }
  } = useThree()
/* 
  gyro.stopTracking() // Stop periodic calls
  gyro.calibrate() // Calibrate measurement during the page loading
 */
  const controls = useRef()
  /*useFrame(state => {
    const o = gyro.getOrientation()
    const [x, y] = controls.current.position0
    controls.current.target.set(o.alpha , o.beta , o.gamma)
    controls.current.position0.set(o.alpha + (x * 0.1), o.beta + (y * 0.1)) 
    controls.current.update()
  }) */
  return (
    <orbitControls
      ref={controls}
      args={[camera, domElement]}
      zoomSpeed={0.5}
      minDistance={.1}
      maxDistance={4}
    />
  )
}

